import { MainServerApiServiceInstance } from './MainServerApi.service';
import { MainBackendSuccessResponse } from '@flicent/fieldpulse-react-component-library-frontend';


interface RequestParams {
  token: string;
  formId: number;
}

interface ResponseDataType extends MainBackendSuccessResponse<{
  email_subject: string;
  email_body: string;
  sms_body: string;
}> {
}

export const getCustomFormFilledCommunicationTemplateRequest = ({
                                                                  token,
                                                                  formId,
                                                                }: RequestParams): Promise<ResponseDataType> => {
  return MainServerApiServiceInstance.makeRequest(`/custom-form/${ formId }/filled-communication-template`, {
    token,
  });
};